import { render, staticRenderFns } from "./comScreenDP.vue?vue&type=template&id=7b21b642&"
import script from "./comScreenDP.vue?vue&type=script&lang=js&"
export * from "./comScreenDP.vue?vue&type=script&lang=js&"
import style0 from "./comScreenDP.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports